import React, { useContext } from 'react';

import DedicatedContractsAssignmentContext from '../context';

import {
  StyledCard,
  StyledHeader,
  StyledSidebar,
  StyledContent,
  StyledAssignWrapper,
  StyledCardWrapper,
} from 'modules/assignment-cards/styled';

import { VehicleInfo, JourneysInfo } from 'modules/assignment-cards/components';

import HeaderInfo from './HeaderInfo';

const DedicatedContractCard = ({
  id,
  isFirst,
  vertical,
  assignActionComponent: AssignActionComponent = null,
}) => {
  const {
    fetchingJourneys,
    journeysByDriver = {},
    dedicatedContractsObject,
  } = useContext(DedicatedContractsAssignmentContext);

  const contract = dedicatedContractsObject[id] || {};

  const { driver = {}, vehicle = {} } = contract;

  return (
    <StyledCardWrapper vertical={vertical}>
      <StyledCard data-testid="contract_card" isFirst={isFirst} vertical={vertical}>
        <StyledHeader>
          <HeaderInfo id={id} />
        </StyledHeader>
        <StyledSidebar>
          <VehicleInfo model={contract} />
        </StyledSidebar>
        <StyledContent vertical={vertical}>
          {!!AssignActionComponent && (
            <StyledAssignWrapper>
              <AssignActionComponent driverId={driver?.id} vehicleIds={[vehicle.id]} />
            </StyledAssignWrapper>
          )}
          <JourneysInfo
            id={id}
            journeys={(journeysByDriver || {})[driver.id]}
            fetching={fetchingJourneys}
          />
        </StyledContent>
      </StyledCard>
    </StyledCardWrapper>
  );
};

export default DedicatedContractCard;
